import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface Experiment {
  name: string;
  variant: string;
  modelExecutionIds: string[];
}
export interface ExperimentsReducer {
  [experimentKey: string]: Experiment;
}

const initialState: ExperimentsReducer = {};

const experimentsReducer = createSlice({
  name: 'experiments',
  initialState,
  reducers: {
    addExperiment(state, action: PayloadAction<Experiment>) {
      state[action.payload.name] = action.payload;
    },
    addExperiments(state, action: PayloadAction<Experiment[]>) {
      action.payload.forEach(
        (experiment) => (state[experiment.name] = experiment)
      );
    },
  },
});

export const { addExperiment, addExperiments } = experimentsReducer.actions;
export default experimentsReducer.reducer;
